import { hero, heroStats } from "@/mocks/homeContent";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20moody%20evening%20cityscape%20seen%20through%20rain%20streaked%20glass%2C%20warm%20amber%20street%20lights%20and%20deep%20crimson%20sky%2C%20soft%20bokeh%2C%20painterly%20texture%2C%20melancholic%20literary%20atmosphere%2C%20muted%20warm%20palette%20with%20subtle%20grain%2C%20no%20people%2C%20editorial%20book%20cover%20mood%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=900&seq=nfw-hero-city-01&orientation=landscape"
        alt={hero.bgAlt}
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/75 to-foreground-950/90"></div>

      <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-12 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-[1.15fr_0.85fr]">
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs font-medium tracking-wide text-background-100 backdrop-blur">
            <i className="ri-quill-pen-line text-accent-300"></i>
            {hero.kicker}
          </span>

          <h1 className="mt-6 font-display text-4xl leading-tight text-background-50 md:text-6xl">
            {hero.title}
          </h1>
          <p className="mt-3 font-heading text-lg text-accent-300 md:text-2xl">{hero.subtitle}</p>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200/90 md:text-base">
            {hero.intro}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={hero.primaryHref}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-open-line"></i>
              {hero.primaryCta}
            </a>
            <a
              href={hero.secondaryHref}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-links-line"></i>
              {hero.secondaryCta}
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-6 border-t border-background-50/15 pt-8 sm:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <dt className="font-display text-3xl text-accent-300 md:text-4xl">{stat.value}</dt>
                <dd className="mt-1 text-xs leading-relaxed text-background-200/80">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="flex w-full justify-center lg:justify-end">
          <div className="w-full max-w-xs">
            <div className="rotate-1 rounded-lg border border-background-50/15 bg-background-950/40 p-3 backdrop-blur transition-transform duration-300 hover:rotate-0">
              <div className="overflow-hidden rounded-md">
                <img
                  src="https://readdy.ai/api/search-image?query=stylized%20minimalist%20book%20cover%20artwork%2C%20abstract%20intertwined%20ribbons%20and%20torn%20paper%20texture%2C%20warm%20ivory%20background%20with%20deep%20crimson%20and%20amber%20accents%2C%20melancholic%20literary%20mood%2C%20soft%20grain%2C%20elegant%20negative%20space%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=800&height=1000&seq=nfw-cover-01&orientation=portrait"
                  alt={hero.coverAlt}
                  className="h-[360px] w-full object-cover object-top md:h-[420px]"
                />
              </div>
              <div className="flex items-center justify-between px-1 pt-3">
                <span className="text-xs text-background-200/80">伦理 · 婚恋 · 长篇</span>
                <span className="inline-flex items-center gap-1 text-xs text-accent-300">
                  <i className="ri-eye-line"></i>
                  导读版
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}